import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useAuth } from "../context/AuthContext";
import GoogleLoginButton from "../components/GoogleLoginButton";

function Connexion() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login, googleLogin } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const user = await login(email, password);
      if (user.role === "admin") navigate("/admin");
      else navigate("/mon-espace");
    } catch (err) {
      setError(err.response?.data?.message || "Email ou mot de passe incorrect");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Navbar />
      <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#f9fafb", padding: "60px 20px" }}>
        <div style={{ width: "100%", maxWidth: "480px" }}>
          <div style={{ backgroundColor: "white", padding: "40px", borderRadius: "16px", boxShadow: "0 4px 20px rgba(0,0,0,0.1)" }}>
            <div style={{ textAlign: "center", marginBottom: "30px" }}>
              <h1 style={{ fontSize: "28px", fontWeight: "700", color: "#1f2937", marginBottom: "8px" }}>
                Marina<span style={{ color: "#0d9488" }}>DZ</span>
              </h1>
              <h2 style={{ fontSize: "22px", fontWeight: "600", color: "#1f2937", marginBottom: "8px" }}>Connexion</h2>
              <p style={{ color: "#6b7280", fontSize: "14px" }}>Accédez à votre compte MarinaDZ</p>
            </div>

            {error && (
              <div style={{ backgroundColor: "#fef2f2", border: "1px solid #fecaca", borderRadius: "8px", padding: "12px 15px", marginBottom: "20px", color: "#dc2626", fontSize: "14px" }}>
                {error}
              </div>
            )}

            <div style={{ marginBottom: "20px" }}>
              <GoogleLoginButton
                onSuccess={async (data) => {
                  setError("");
                  setLoading(true);
                  try {
                    const user = await googleLogin({ credential: data.credential });
                    if (user.role === "admin") navigate("/admin");
                    else navigate("/mon-espace");
                  } catch (err) {
                    setError(err.response?.data?.message || "Erreur lors de la connexion Google");
                  } finally {
                    setLoading(false);
                  }
                }}
                onError={(msg) => setError(msg || "Erreur Google")}
                label="Se connecter avec Google"
              />
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "20px" }}>
              <div style={{ flex: 1, height: "1px", backgroundColor: "#e5e7eb" }} />
              <span style={{ fontSize: "13px", color: "#9ca3af" }}>ou avec votre email</span>
              <div style={{ flex: 1, height: "1px", backgroundColor: "#e5e7eb" }} />
            </div>

            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: "20px" }}>
                <label style={{ display: "block", fontSize: "14px", fontWeight: "500", color: "#374151", marginBottom: "8px" }}>Adresse email</label>
                <input
                  type="email" value={email} onChange={e => { setEmail(e.target.value); setError(""); }}
                  placeholder="votre@email.com" required
                  style={{ width: "100%", padding: "12px 15px", border: "1.5px solid #e5e7eb", borderRadius: "8px", fontSize: "14px", outline: "none", boxSizing: "border-box", fontFamily: "inherit" }}
                  onFocus={e => e.target.style.borderColor = "#0d9488"}
                  onBlur={e => e.target.style.borderColor = "#e5e7eb"}
                />
              </div>

              <div style={{ marginBottom: "20px" }}>
                <label style={{ display: "block", fontSize: "14px", fontWeight: "500", color: "#374151", marginBottom: "8px" }}>Mot de passe</label>
                <div style={{ position: "relative" }}>
                  <input
                    type={showPassword ? "text" : "password"} value={password}
                    onChange={e => { setPassword(e.target.value); setError(""); }}
                    placeholder="••••••••" required
                    style={{ width: "100%", padding: "12px 44px 12px 15px", border: "1.5px solid #e5e7eb", borderRadius: "8px", fontSize: "14px", outline: "none", boxSizing: "border-box", fontFamily: "inherit" }}
                    onFocus={e => e.target.style.borderColor = "#0d9488"}
                    onBlur={e => e.target.style.borderColor = "#e5e7eb"}
                  />
                  <button type="button" onClick={() => setShowPassword(v => !v)}
                    style={{ position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", color: "#9ca3af" }}>
                    {showPassword ? (
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24"/>
                        <line x1="1" y1="1" x2="23" y2="23"/>
                      </svg>
                    ) : (
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                        <circle cx="12" cy="12" r="3"/>
                      </svg>
                    )}
                  </button>
                </div>
              </div>

              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "25px" }}>
                <label style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "14px", color: "#6b7280", cursor: "pointer" }}>
                  <input type="checkbox" style={{ accentColor: "#0d9488" }} />
                  Se souvenir de moi
                </label>
                <Link to="/mot-de-passe-oublie" style={{ fontSize: "14px", color: "#0d9488", textDecoration: "none", fontWeight: "500" }}>
                  Mot de passe oublié ?
                </Link>
              </div>

              <button type="submit" disabled={loading}
                style={{ width: "100%", padding: "14px", backgroundColor: loading ? "#9ca3af" : "#0d9488", color: "white", border: "none", borderRadius: "8px", fontSize: "15px", fontWeight: "600", cursor: loading ? "not-allowed" : "pointer", marginBottom: "20px", fontFamily: "inherit" }}>
                {loading ? "Connexion en cours..." : "Se connecter"}
              </button>
            </form>

            <p style={{ textAlign: "center", fontSize: "14px", color: "#6b7280" }}>
              Pas encore de compte ?{" "}
              <Link to="/inscription" style={{ color: "#0d9488", textDecoration: "none", fontWeight: "600" }}>S'inscrire</Link>
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Connexion;